import { useCallback } from 'react';

import { Copy } from 'lucide-react';

import type { InputProps } from '@/_components';
import { FormControl, FormItem, FormMessage, Input } from '@/_components';
import { urlSchemeNative } from '@/_schemas/generic';
import { snackbar, useCopyToClipboard } from '@/_shared';

import { ActionButton } from '../actions';

export const FormInputUrl = ({
  ref,
  formItemClassName,
  value,
  className,
  web,
  ...props
}: InputProps & { formItemClassName?: string; web?: string }) => {
  const { copy } = useCopyToClipboard();
  const handleOpen = useCallback(() => {
    if (props.disabled && value) {
      let link = value;
      if (web) {
        link = web + value;
      }

      if (urlSchemeNative.safeParse(link as string).success) {
        return window.open(link as string, '_blank');
      }

      return snackbar.error("Invalid link, couldn't open.");
    }

    return null;
  }, [props.disabled, value, web]);

  return (
    <FormItem className={formItemClassName}>
      <FormControl>
        <Input
          {...props}
          containerProps={{
            onClick: handleOpen,
            className: props.disabled && Boolean(value) ? 'cursor-pointer group' : '',
          }}
          className={`${className} decoration-primary decoration-2 disabled:pointer-events-none group-hover:disabled:underline`}
          value={`${value || ''}`.toLowerCase()}
          onChange={(e) =>
            props?.onChange?.({ ...e, target: { ...e.target, value: `${e.target.value || ''}`.toLowerCase() } })
          }
          ref={ref}
          postSlot={
            <ActionButton
              title={`Copy ${props.label}`}
              disabled={!value}
              icon={Copy}
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                if (value) {
                  copy(value as string);
                  snackbar.success(`${value} has been copied to clipboard`);
                }
              }}
            />
          }
        />
      </FormControl>
      <FormMessage />
    </FormItem>
  );
};
